import { Object } from "core-js";

export default Object.freeze({
    Intro: 'Intro',
    MissedDelivery: 'MissedDelivery',
    Confirmation: 'Confirmation',
    PreDeliveryRedirection: 'PreDeliveryRedirection',
    PageNotFound: 'NotFound'
});